import ButtonBase from "@mui/material/ButtonBase";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { numberWithCommas } from "../../utils";
import { MonthFilter } from "./dailyExpenseMonth";

const CARD_MIN_WIDTH = 160;

interface SummaryCard {
  filter: MonthFilter;
  label: string;
  count: number;
  /** The colour a non-zero count is drawn in: the boxes that ask the branch for something. */
  alertColor?: string;
}

interface MonthSummaryCardsProps {
  totalCount: number;
  notStartedCount: number;
  rejectedCount: number;
  filter: MonthFilter;
  onSelect: (filter: MonthFilter) => void;
}

/** ทั้งหมด · ยังไม่กรอก · ถูกตีกลับ — each box filters the list to its days. */
export default function MonthSummaryCards({
  totalCount,
  notStartedCount,
  rejectedCount,
  filter,
  onSelect,
}: Readonly<MonthSummaryCardsProps>) {
  const cards: SummaryCard[] = [
    { filter: "ALL", label: "ทั้งหมด", count: totalCount },
    {
      filter: "NOT_STARTED",
      label: "ยังไม่กรอก",
      count: notStartedCount,
      alertColor: "warning.dark",
    },
    { filter: "REJECTED", label: "ถูกตีกลับ", count: rejectedCount, alertColor: "error.main" },
  ];
  const selectCard = (card: SummaryCard) => () => onSelect(card.filter);

  return (
    <Stack direction="row" gap={1.5} flexWrap="wrap">
      {cards.map((card) => (
        <ButtonBase
          key={card.filter}
          onClick={selectCard(card)}
          aria-pressed={filter === card.filter}
          sx={{
            minWidth: CARD_MIN_WIDTH,
            px: 2,
            py: 1.5,
            borderRadius: 3,
            bgcolor: "background.paper",
            border: 2,
            borderColor: filter === card.filter ? "primary.main" : "background.paper",
            justifyContent: "flex-start",
          }}
        >
          <Stack alignItems="flex-start">
            <Typography variant="body2" color="text.secondary" noWrap>
              {card.label}
            </Typography>
            <Typography
              variant="h6"
              fontWeight={600}
              color={card.count > 0 && card.alertColor ? card.alertColor : "text.primary"}
            >
              {numberWithCommas(card.count)} วัน
            </Typography>
          </Stack>
        </ButtonBase>
      ))}
    </Stack>
  );
}
